import React, { useState, useEffect, useRef } from "react";
import instance from "../../../store/actions/instance";
export default function MapSearchInput({
  language,
  countryCodes = ["kw", "eg", "sa", "bh", "om", "qa"],
  onSelect,
}) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (query.length < 3) {
      setResults([]);
      return;
    }
    // ✅ debounce
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      const controller = new AbortController();

      instance
        .post("/map_search/", {
          query,
          language: language === "arabic" ? "ar" : "en",
          country_codes: countryCodes,
        })
        .then((res) => {
          setResults(res.data?.results || []);
        })
        .catch(() => {});

      return () => controller.abort();
    }, 400); // 👈 debounce delay

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [query, language, countryCodes]);

  return (
    <div className="map-search-wrapper">
      <input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={
          language === "arabic"
            ? "ابحث عن شارع أو منطقة أو معلم"
            : "Search street, area, or landmark"
        }
        className={`map-search-input ${language === "arabic" ? "rtl" : ""}`}
      />

      {results.length > 0 && (
        <div className="map-search-results">
          {results.map((r, idx) => (
            <div
              key={idx}
              className="map-search-item"
              onClick={() => {
                onSelect({
                  lat: parseFloat(r.lat),
                  lng: parseFloat(r.lng),
                  raw: r,
                });
                setQuery("");
                setResults([]);
              }}
            >
              {r.display_name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
